import { request } from '@/common/utils/request'

export function queryTask (query) {
  return request.get({
    url: 'pms.bdapp.task.task.getList',
    params: query
  })
}

export function transactTask (query) {
  return request.post({
    url: 'pms.bdapp.task.task.distribute',
    params: query
  })
}

// 不知道需不需要用
export function closeTask(query) {
  return new Promise((resolve, reject) => {
    resolve('ok')
  })
}

export function pickTask (query) {
  return request.post({
    url: 'pms.bdapp.task.task.receive',
    params: query
  })
}
// 任务详情
export function getTaskDetail (query) {
  return request.get({
    url: 'crm.bdapp.task.onboarding.getDetail',
    params: {
      ...query
    }
  })
}

export function queryTeamMember (query) {
  return request.get({
    url: 'pms.bdapp.task.team.members',
    params: {
      ...query,
      pageNo: 1,
      pageSize: 999
    }
  })
}

export function taskType (source) {
  return request.get({
    url: 'pms.bdapp.task.task.getTypeListBySource',
    params: source
  })
}

export function taskSource (query) {
  return request.get({
    url: 'pms.bdapp.task.task.getSourceList',
    params: query
  })
}
// 任务完成
export function completeTask (query) {
  return request.post('crm.bdapp.task.onboarding.completeTask', {
    data: query
  })
}
